import { useTranslation } from 'react-i18next';
import { LayoutGridIcon, ListIcon } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '@monksflow/monks-ui';
import {
  ANALYSIS_VIEW_MODE,
  type AnalysisViewMode,
  type ViewToggleProps,
} from './ViewToggle.types';

export function ViewToggle({ value, onChange }: ViewToggleProps) {
  const { t } = useTranslation('analysis');

  return (
    <Tabs
      value={value}
      onValueChange={(next) => onChange(next as AnalysisViewMode)}
      data-testid="analysis-view-toggle"
    >
      <TabsList>
        <TabsTrigger value={ANALYSIS_VIEW_MODE.grid} aria-label={t('analysis.viewToggle.gridView')}>
          <LayoutGridIcon className="size-4" />
          {t('analysis.viewToggle.grid')}
        </TabsTrigger>
        <TabsTrigger value={ANALYSIS_VIEW_MODE.list} aria-label={t('analysis.viewToggle.listView')}>
          <ListIcon className="size-4" />
          {t('analysis.viewToggle.list')}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
